import {
  PredefinitionPropertyHandler,
  skapaPrefixService
} from "@ingka/webc-tools";
const tagnameTemplatesForPrefixService = /* @__PURE__ */ new Map();
const DEFAULT_TASK_ID = "__skapa_default_task";
class SkapaElement extends HTMLElement {
  constructor() {
    super(...arguments);
    this.tasks = /* @__PURE__ */ new Map();
    this.__updateTaskID = -1;
    this.gatherProperties = PredefinitionPropertyHandler.gatherProperties;
    this.initGatheredProperties = PredefinitionPropertyHandler.initGatheredProperties;
    this.getPrefixService = () => {
      return this.constructor.prefixService;
    };
    this.getPrefixedTagName = (tagName) => {
      return `${this.getPrefixService().prefix}-${tagName}`;
    };
    this.get$ = (selector) => {
      return this.shadowRoot.querySelector(
        this.getPrefixService().prefixReplacer(selector)
      );
    };
    this.micro = (task, taskName = DEFAULT_TASK_ID, delay) => {
      if (typeof window !== "undefined") {
        clearTimeout(this.tasks.get(taskName));
        this.tasks.set(taskName, window.setTimeout(task, delay));
      }
    };
  }
  /**
   * Retrieves the templates for Skapa Web components.
   * The templates are partial DOM trees that will be cloned for each instance of the component.
   * Using this is faster than creating the DOM tree from scratch for each instance.
   * @param generateTemplate Function that generates prefix sensitive templates for the component.
   * @returns
   */
  getTemplates(generateTemplate, customName) {
    const prefixService = this.getPrefixService();
    const tagName = customName ?? this.constructor.skapaTagName;
    let prefixedTemplateStore = tagnameTemplatesForPrefixService.get(prefixService);
    let templates = prefixedTemplateStore && prefixedTemplateStore.get(tagName);
    if (!templates) {
      if (!prefixedTemplateStore) {
        prefixedTemplateStore = /* @__PURE__ */ new Map();
        tagnameTemplatesForPrefixService.set(
          prefixService,
          prefixedTemplateStore
        );
      }
      templates = generateTemplate(prefixService);
      prefixedTemplateStore.set(tagName, templates);
    }
    return templates;
  }
  connectedCallback() {
    this.initGatheredProperties(this);
  }
  disconnectedCallback() {
    if (typeof window !== "undefined") {
      this.tasks.forEach((taskID) => window.clearTimeout(taskID));
      this.tasks.clear();
    }
  }
}
SkapaElement.prefixService = skapaPrefixService;
SkapaElement.skapaTagName = "";
SkapaElement.skapaDependencies = [];
SkapaElement.skapaIconDependencies = [];
var SkapaElement_default = SkapaElement;
export {
  SkapaElement,
  SkapaElement_default as default
};
